module.exports = __webpack_public_path__ + "img/trash.20dc2d05.svg";